module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 86300.9a2e8082.png";